import { forwardRef } from 'react';
import { LayoutGroup } from 'motion/react';
import type { CommonHTMLAttributes } from '@frontend/types';
import { TabsStyles } from '../common-styles';

export type TabBarProps = CommonHTMLAttributes & {
  activeTab: string | undefined;
  children: Array<JSX.Element | boolean | null>;
  fullWidth?: boolean;
  isScrollable?: boolean;
  uniqueId?: string;
};

export const TabBar = forwardRef<HTMLDivElement, TabBarProps>(
  ({ activeTab, children, fullWidth, isScrollable, uniqueId, ...rest }, ref) => {
    const styles = TabsStyles.tabBar({ fullWidth, isScrollable });

    return (
      <div ref={ref} css={styles} role='tablist' {...rest}>
        <LayoutGroup id={uniqueId}>{children}</LayoutGroup>
      </div>
    );
  }
);
